import { getEditableField } from '../store/selectors';
export var validateContent = function (params) {
    var store = params.store;
    var state = store.getState();
    var sendSms = getEditableField(state, 'sendSms').value;
    var sendPush = getEditableField(state, 'sendPush').value;
    var sendEmail = getEditableField(state, 'sendEmail').value;
    var smsBody = getEditableField(state, 'smsBody').value;
    var pushBody = getEditableField(state, 'pushBody').value;
    var emailSubject = getEditableField(state, 'emailSubject').value;
    var emailTitle = getEditableField(state, 'emailTitle').value;
    var isValid = true;
    var errors = [];
    if (sendEmail) {
        if (!emailSubject) {
            isValid = false;
            errors.push({ field: 'emailSubject', message: 'Subject is required' });
        }
        if (!emailTitle) {
            isValid = false;
            errors.push({ field: 'emailTitle', message: 'Title is required' });
        }
    }
    if (sendSms) {
        if (!smsBody && !emailTitle) {
            isValid = false;
            errors.push({ field: 'smsBody', message: 'SMS message is required' });
        }
    }
    if (sendPush) {
        if (!pushBody && !emailTitle) {
            isValid = false;
            errors.push({ field: 'pushBody', message: 'Push notification message is required' });
        }
    }
    return {
        isValid: isValid,
        errors: errors,
    };
};
